<template>
  <fragment>
    <div class="modal-title">
      Share your VALUATION!
      <i class="modal-close-button" @click="$emit('close')"></i>
    </div>

    <div class="modal-body">
      <h3 style="text-align: center">
        <strong>Celebrate the value of your startup with your friends.
        </strong>
      </h3>
      <br/>
      <div v-if="loading">
        Loading ..
      </div>
      <div class="columns">
        <div class="column is-12" ref="addthis">
          <div class="addthis_inline_share_toolbox" style="text-align: center" :data-title="title" :data-url="url"></div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import {ReportAPI} from "@/apis/ReportAPI";

export default {
  name: "ShareModal",
  data() {
    return {
      copied: false,
      url: 'Loading..',
      loading: true
    }
  },
  props: ['reportId'],
  async mounted() {
    const resp = (await ReportAPI.generateShareURL(this.reportId))
    this.url = resp.url
    this.title = resp.title
    this.loading = false;
    addthis && addthis.layers.refresh();
  },
  methods: {
    copy() {
      const copyText = this.$refs.copyTextRef;
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(copyText.value);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 5000)
    }
  }
}
</script>

<style scoped>
.copied {
  font-size: 11px;
  padding: 4px;
  text-align: center;
}

.copy-btn {

}

.modal-title {
  padding-left: 30px;
  background-image: none;
}
</style>
